import { useQueryHelper } from '@anytag/shared-hooks';
import { PostDetailsType } from '@anytag/shared-types';
import { useInstagramAmbassadorPostDetailsQuery } from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export type TemplatePostDetailsType = Pick<PostDetailsType, 'id' | 'mainSocialAccountId'>;

export interface TemplateProps {
  className?: string;
}

export const Template = ({ className }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPost } = usePostModalContext<TemplatePostDetailsType>();
  const { data, loading } = useInstagramAmbassadorPostDetailsQuery({
    skip: !selectedPost?.id || !selectedPost?.mainSocialAccountId,
    variables: { postId: String(selectedPost?.id), accountId: Number(selectedPost?.mainSocialAccountId) },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });

  const details = data?.instagramAmbassadorPostDetails;

  return (
    <PostModal.DetailsTemplate
      loading={loading}
      className={className}
      data={
        details
          ? {
              socialMedia: 'INSTAGRAM',
              postUrl: details?.postUrl,
              caption: details?.content,
              info: { name: details?.username },
              images: details?.thumbNail ? [details.thumbNail] : [],
              statistics: { likes: details?.likes, comments: details?.comments }
            }
          : undefined
      }
    />
  );
};
